import React, { useContext, useEffect} from "react";//

import { Redirect, useHistory, useLocation } from "react-router-dom"; 
import AuthenticationContext from "../../contexts/AuthenticationContext";
import { AppDivisionContext } from "../../contexts/AppDivisionContext";
import divisionApi from "../../utils/api/division";


/**
 * Compute the home page route, depending on user auth status
 */
const HomePage = () => {
  const authStore = useContext(AuthenticationContext);
  const history = useHistory();
  const location = useLocation();
  const appDivisionContext = useContext(AppDivisionContext);

  const fetchDivisionAndRedirect = async () => {
    // Check if there's a 'to' parameter in the URL
    const urlSearchParams = new URLSearchParams(location.search);
    const targetPath = urlSearchParams.get('to');
    
    if (targetPath && targetPath !== '/') {
      // If there's a target path, redirect to it via identity-auth
      history.push(`/identity-auth?to=${encodeURIComponent(targetPath)}`);
      return;
    }
    
    // Otherwise, redirect to dashboard as usual
    let division: any[];

    try {
      division = await divisionApi.index();
    } catch (err) {
      // SW2-2475: offline (or unreachable) with no cached division list, this rejected and the
      // home page stayed blank. Go to the last division the app was on instead.
      history.push(appDivisionContext.getPath('/dashboard'));

      return;
    }

    const divisionId = division.length
      ? division[0].id
      : appDivisionContext.getPath('/dashboard');

    history.push(`/divisions/${divisionId}/dashboard`);
  }

  // Before any return: a hook after the early return below broke the rules of hooks.
  useEffect(() => {
    if (authStore.loggedIn) fetchDivisionAndRedirect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!authStore.loggedIn) {
    return <Redirect to='/login' push={false} />;
  }

  return <></>;

  // return <Redirect to={appDivisionContext.getPath("/dashboard")} push={false} />;
};

export default HomePage;
